import api, { apiWrapper } from '../api/axios';

export const getTrips = async (
  {
    type,
    branch,
    requested_vehicle,
    assigned_vehicle,
    driver,
    status,
    customer,
    created_at,
    booking_date,
    expected_pickup_date,
    placement_pickup_date,
    actual_in_pickup_date,
    actual_out_pickup_date,
    expected_delivery_date,
    actual_in_delivery_date,
    actual_out_delivery_date,
    search = null,
    page = 1,
    pageSize = 20,
    paginate = true
  }
) => {
  let params = {
    type,
    branch,
    requested_vehicle,
    assigned_vehicle,
    driver,
    status,
    customer,
    created_at,
    booking_date,
    expected_pickup_date,
    placement_pickup_date,
    actual_in_pickup_date,
    actual_out_pickup_date,
    expected_delivery_date,
    actual_in_delivery_date,
    actual_out_delivery_date,
    page,
    page_size: pageSize,
    paginate: paginate
  };
  if (search != null) {
    params = { ...params, search };
  }
  return apiWrapper(() => api.get(`/trip/`, { params }));
};

export const getTrip = async (id) => {
  return apiWrapper(() => api.get(`/trip/${id}/`));
};

export const createTrip = async (data) => {
  return apiWrapper(() => api.post("/trip/", data), false);
};

export const updateTrip = async (id, data) => {
  return apiWrapper(() => api.put(`/trip/${id}/`, data), false);
};

export const updateTripPartial = async (id, data) => {
  return apiWrapper(() => api.patch(`/trip/${id}/`, data), false);
};

export const uploadManifest = async (id, data) => {
  let form = new FormData();
  form = add_field(form, 'client_id', data?.client_id);
  form = add_field(form, 'manifest', data?.manifest);
  return apiWrapper(() => api.post(`/trip/${id}/upload-manifest/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }));
};

export const updateStatus = async (id, state) => {
  const data = { state }
  return apiWrapper(() => api.post(`/trip/${id}/update-state/`, data));
};

export const getManifestDownloadUrl = async (tripId, clientId) => {
  return apiWrapper(() => api.get(`/trip/${tripId}/download-manifest/${clientId}/`));
};

export const uploadConsignmentDocuments = async (tripId, consignmentId, files) => {
  const form = new FormData();
  form.append('consignment_id', consignmentId);
  files.forEach((f) => form.append('files', f));
  return apiWrapper(() => api.post(`/trip/${tripId}/upload-consignment-document/`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }));
};

export const getConsignmentDocumentDownloadUrl = async (tripId, docId) => {
  return apiWrapper(() => api.get(`/trip/${tripId}/download-consignment-document/${docId}/`));
};

export const deleteConsignmentDocument = async (tripId, docId) => {
  return apiWrapper(() => api.delete(`/trip/${tripId}/delete-consignment-document/${docId}/`));
};

export const downloadTripDocuments = async (tripId, tripCode) => {
  try {
    // Use fetch directly to bypass the axios interceptor, which swallows
    // non-2xx responses and hands back the error Blob as if it were success.
    const token = localStorage.getItem('access_token');
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const response = await fetch(
      `${baseUrl}/api/trip/${tripId}/download-all-documents/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!response.ok) {
      // Parse the JSON error body ({"success":false,"message":...,"errors":{...}})
      let message = 'No documents found for this trip.';
      try {
        const json = await response.json();
        message = json?.errors?.error || json?.message || message;
      } catch (_) { /* ignore parse error, keep default */ }
      return [{ message }, null];
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${tripCode || tripId}_documents.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return [null, true];
  } catch (err) {
    return [{ message: 'Failed to download documents.' }, null];
  }
};

export const downloadManifestPdf = async (tripId, tripCode) => {
  try {
    const token = localStorage.getItem('access_token');
    const baseUrl = import.meta.env.VITE_BASE_URL;
    const response = await fetch(
      `${baseUrl}/api/trip/${tripId}/download-manifest-pdf/`,
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (!response.ok) {
      let message = 'Failed to generate manifest PDF.';
      try {
        const json = await response.json();
        message = json?.error || json?.message || message;
      } catch (_) { /* ignore */ }
      return [{ message }, null];
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Manifest_${tripCode || tripId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return [null, true];
  } catch (err) {
    return [{ message: 'Failed to download manifest PDF.' }, null];
  }
};

const add_field = (form, key, value) => {
  if (value) {
    form.append(key, value);
  }
  return form;
};
